<template>
  <div class="tariff-info">
    <span v-if="$props.cycleEnd" class="tariff-info-cycle">{{ $props.cycleEnd }} X</span>
    <span class="tariff-info-price">{{ $props.price }}</span>
    <span class="tariff-info-currency">{{ $props.currency }}</span>
    <button class="tariff-info-remove" ref="deleteTariff" :class="{'trash-can': !$props.brand}" @click="removeFromCart($props.entryNumber)">
      <img :src="$props.icon" alt="">
    </button>
  </div>
</template>

<script>
import { customEvent } from '@/services/customEventBus'

export default {
  name: 'tariff-info',
  props: {
    cycleEnd: Number,
    price: [Number, String],
    currency: String,
    brand: String,
    icon: String,
    entryNumber: Number
  },

  methods: {
    removeFromCart (entry) {
      customEvent.$emit('remove-from-cart', entry)
    },
    forceDelete () {
      this.$refs.deleteTariff.click()
      customEvent.$emit('close-mini-cart')
    }
  },

  mounted () {
    customEvent.$on('force-delete', this.forceDelete)
  },

  destroyed () {
    customEvent.$off('force-delete')
  }
}
</script>

<style lang="scss" scoped>
.tariff-info {
  margin-left: auto;
  color: $checkbox-label;
  font-size: 1.2rem;
  font-weight: 600;
}

.tariff-info-price {
  margin: 0 .5rem;
  color: $mtel-red;
  font-size: 1.6rem;
}

.tariff-info-currency {
  text-transform: lowercase;
}

.tariff-info-remove {
  position: relative;
  top: -.3rem;
  margin-left: 2rem;
  padding: 0;

  &.trash-can {
    margin-right: -.4rem;
    margin-left: 1.6rem;
  }
}
</style>
